import * as types from './action_types';
import WordService from '../../services/word_service';
import WordMapper from '../utils/word_mapper';

export const reset = () => {
  return { type: types.WORD_RESET };
}

export const fetch = (wordText, targetLanguage = 'en') => {
  return async(dispatch) => {
    try {
      dispatch({ type: types.WORD_RETRIEVING });
      const wordData = await WordService.fetch(wordText, targetLanguage);
      const word = WordMapper.map(wordData);
      dispatch({ type: types.WORD_RETRIEVED, word });
    } catch(error) {
      dispatch({ type: types.WORD_RETRIEVAL_ERROR, error });
    }
  }
}



// WEBPACK FOOTER //
// ./src/stores/word/actions.js